import * as React from "react";

const SvgGoustoG: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3542 1.88059C18.1737 1.69988 18.053 1.63989 17.9025 1.63989C17.7221 1.63989 17.6014 1.69988 17.3907 1.91058L15.5541 3.62692C14.5606 2.93433 13.3264 2.54293 12.0015 2.54293C8.71975 2.54293 5.98016 4.98159 5.98016 8.44376C5.98016 11.9062 8.71975 14.3448 12.0015 14.3448C15.2832 14.3448 18.023 11.9062 18.023 8.44376C18.023 7.36002 17.7521 6.36651 17.3004 5.52371L19.1672 3.71715C19.3777 3.53644 19.4079 3.35598 19.4079 3.23526C19.4079 3.0548 19.3477 2.96457 19.137 2.72363L18.3542 1.88059ZM12.0015 11.9967C10.0444 11.9967 8.44906 10.4008 8.44906 8.44376C8.44906 6.48698 10.0444 4.89136 12.0015 4.89136C13.9585 4.89136 15.5541 6.48698 15.5541 8.44376C15.5541 10.4008 13.9585 11.9967 12.0015 11.9967ZM17.4809 15.0072H16.2167C15.7348 15.0072 15.5841 15.1879 15.5841 15.6093C15.4939 17.5061 14.0187 19.0717 12.0015 19.0717C10.0444 19.0717 8.50905 17.5061 8.41882 15.6093C8.41882 15.1879 8.26836 15.0072 7.78672 15.0072H6.52203C6.07039 15.0072 5.91992 15.1879 5.91992 15.5793C5.91992 18.7405 8.56929 21.4199 12.0015 21.4199C15.4336 21.4199 18.083 18.7405 18.083 15.5793C18.083 15.1879 17.9325 15.0072 17.4809 15.0072Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgGoustoG;
